<template>
  <div>
    <layout>
      <el-form :model="dataForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <el-form-item prop="mobile">
          <el-input class="input" v-model="dataForm.mobile" placeholder="输入手机号码">
            <template slot="prepend">
              手机号
              <span class="after"></span>
            </template>
          </el-input>
        </el-form-item>
       
        <el-form-item prop="password">
          <el-input class="input" type="password" v-model="dataForm.password" placeholder="输入密码">
            <template slot="prepend">
              密码
              <span class="after"></span>
            </template>
          </el-input>
        </el-form-item>
         <el-form-item prop="password2">
          <el-input class="input" type="password" v-model="dataForm.password2" placeholder="输入密码">
            <template slot="prepend">
              确认密码
              <span class="after"></span>
            </template>
          </el-input>
        </el-form-item>
         <el-form-item prop="captcha">
          <el-input class="input" type="text" v-model="dataForm.captcha" placeholder="输入验证码">
            <template slot="prepend">
              验证码
              <span class="after"></span>
            </template>
            <template slot="append">
              <div style="width:90px">
                <el-button
                  type="primary"
                  class="getCodeBtn"
                  :disabled="disabled"
                  @click="getCode"
                >{{codeMsg}}</el-button>
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="submit" @click="register">注册</el-button>
        </el-form-item>
      </el-form>
      <!-- <div style="height:174px"></div> -->
      <div style="height:18px"></div>
    </layout>
  </div>
</template>
<script>
import Layout from "../layout";
import reg from "@/utils/regular.js";
export default {
  name: "register",
  components: {
    Layout
  },
  data() {
    let checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      }
      if (value.length!==11) {
        callback(new Error("请输入正确的手机号"));
      }
      callback();
    };
    let checkPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      }
      if (!reg.pwdreg2.test(value)) {
        callback(new Error("请输入8到20位包含字母和数字组合的密码"));
      }
      callback();
    };

    let checkPwd2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      }
      if (value!==this.dataForm.password) {
        callback(new Error("两次密码输入不一致"));
      }
      callback();
    };

    let checkCaptcha = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      }
      callback();
    };
    return {
      rules: {
        mobile: [{ validator: checkPhone, trigger: "blur" }],
        password: [{ validator: checkPwd, trigger: "blur" }],
        password2: [{ validator: checkPwd2, trigger: "blur" }],
        captcha: [{ validator: checkCaptcha, trigger: "blur" }]
      },
      disabled: false,
      dataForm: {
        mobile: "",
        password: "",
        password2: "",
        captcha: ""
      },
      codeMsg:'获取验证码',
      checked: false,
      count: 60,
      timer: null
    };
  },
  methods: {
    // 注册
    register() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const params = { ...this.dataForm };
          this.$request({
            url: "/api/web/register",
            method: "post",
            data: params
          }).then(() => {
            this.$message.success("发送成功");
            this.$router.push("login");
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 获取验证码
    getCode() {
      if(!this.dataForm.mobile){
       return this.$message.error('请输入手机号')
      }
      this.disabled=true
      this.$refs.ruleForm.validateField("mobile", validate => {
        console.log(validate);
        if (!validate) {
          let params = {
            phoneNumber: this.dataForm.mobile,
            flag:1
          };
          this.$request({
            url: "/api/web/sms/note",
            // url: "/api/web/register/note",
            method: "get",
            params: params
          }).then(() => {
            this.disabled = true;
            this.$message.success("发送成功");
            this.timeStart();
          }).catch(()=>{
            this.disabled=false
          })
        }
      });
    },
    timeStart() {
      this.timer = setInterval(() => {
        this.count--;
        if (this.count === 0) {
          this.codeMsg="获取验证码"
          this.count = 60;
          this.disabled = false;
          clearInterval(this.timer);
        }else{
          this.codeMsg=this.count+"s后获取"
        }
      }, 1000);
    }
  }
};
</script>
<style lang="less" scoped>
.el-form-item {
  margin-bottom: 27px;
}

.input {
  background: #fff;
  border: 1px solid #D8D8D8;
  border-radius: 2px;
  /deep/.el-input-group__append {
    background-color: transparent;
    border: none;
    padding: 0;
    font-size: 0;
  }
  /deep/.el-input-group__prepend {
    height: 54px;
    background-color: transparent;
    border: none;
    position: relative;
    color: #9FB2E3;
    width: 56px;
    font-size: 19px;
    .after {
      position: absolute;
      top: 16px;
      right: 0;
      width: 1px;
      height: 20px;
      background-color: #e9e9e9;
    }
  }
  /deep/.el-input__inner {
    background-color: transparent;
    border: none;
    height: 54px;
    font-size: 19px;
  }
  .getCodeBtn {
    font-size: 16px;
    color: #409eff !important;
    &:disabled {
      color: inherit !important;
    }
  }
}
.submit {
  width: 100%;
  height: 63px;
  margin-top: 16px;
  font-size: 19.8px;
  background: #3963ff;
  border: none;
  box-shadow: 0 5px 15px #3963ff;
}
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pdt-40 {
  padding-top: 40px;
}
.icon-title {
  text-align: center;
  margin-top: 20px;
  .link {
    font-size: 26px;
    div {
      font-size: 12px;
    }
  }
}
</style>